import { SpNavigationIsland } from '@portals/ui-kit-dpa';
import { TArticleSectionClickEventParams } from '@/_analytic/events/article-section-click-event/_types';
import { TSearchParams } from '@/_types/route-params';

type TProps = {
  text: string;
  isActive?: boolean;
  isAvailable?: boolean;
  isExpanded?: boolean;
  isExpandable?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
  isArticle?: boolean;
  isTextClamped?: boolean;
  id: string;
  analyticsParams?: TArticleSectionClickEventParams;
  route?: string;
  searchParams?: TSearchParams;
};

export const CategoryButton = ({
  text,
  onClick,
  isDisabled,
  id,
  route,
  searchParams,
  analyticsParams,
}: TProps) => {
  return (
    <SpNavigationIsland.Item
      onSwitch={onClick}
      switchable
      disabled={isDisabled}
      dataTestId="nav-sales-analysis"
      id={id}
      label={text}
      meta={{
        analyticsParams,
        route,
        searchParams,
      }}
    />
  );
};
